const user = {
    state: {
        stepIndex: 0, //步骤
        stepStatus: 1, //步骤状态
        toolTip: "", //提示文本
    },

    mutations: {
        SET_STEP: (state, stepIndex) => {
            state.stepIndex = stepIndex
        },
        SET_STEPSTATUS: (state, stepStatus) => {
            state.stepStatus = stepStatus
        },
        SET_TOOLTIP: (state, toolTip) => {
            state.toolTip = toolTip
        },

    },

    actions: {
        // 机构步骤
        getStepIndex({ commit, state }, data) {
            commit('SET_STEP', data)
        },
        // 审核是否成功
        getStepStatus({ commit, state }, data) {
            commit('SET_STEPSTATUS', data)
        },
        // 审核失败文本
        getToolTip({ commit, state }, data) {
            commit('SET_TOOLTIP', data)
        },
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/org.js